import React from "react";
import { Link } from "react-router-dom";
import { Mail } from "lucide-react";
import "./Footer.css";

const columns = [
  {
    title: "Products",
    links: [
      { label: "Software Development", to: "/software-dev" },
      { label: "Mobile Applications", to: "/mobile-apps" },
      { label: "Microsoft Solutions", to: "/microsoft-solutions" },
      { label: "EdgeNexus", to: "/edge-nexus" },
      { label: "Fiscal Solutions", to: "/fiscal-services" },
      { label: "OmniMart", to: "/omni-mart" },
    ],
  },
  {
    title: "Platforms",
    links: [
      { label: "Form Processing", to: "/power-pages" },
      { label: "GSC Guest House", to: "/gsc-guest-house" },
      { label: "eGRC Solutions", to: "/egrc-solutions" },
    ],
  },
  {
    title: "Company",
    links: [
      { label: "Our Team", to: "/team" },
      { label: "Journal", to: "/blog-posts" },
      { label: "Contact", to: "/contact" },
      { label: "Admin Login", to: "/admin-login" },
    ],
  },
];

export default function Footer() {
  const year = new Date().getFullYear();

  return (
    <footer className="dis-footer dis-on-dark">
      <div className="dis-shell">
        {/* Closing statement — the last piece of display type on the site. */}
        <div className="dis-footer__marque">
          <span className="dis-mono dis-footer__stamp">
            <span className="dis-dot dis-dot--pulse" />
            Est. 2010
          </span>
          <h2 className="dis-display dis-footer__line">
            Let&apos;s build the
            <br />
            next system.
          </h2>
          <Link to="/contact" className="dis-btn dis-btn--light dis-btn--wide">
            Start a conversation
          </Link>
        </div>

        <hr className="dis-rule dis-footer__rule" />

        <div className="dis-footer__grid">
          <div className="dis-footer__brand">
            <img
              src="/images/main-logo-mark.png"
              alt="Diamond Information Systems"
              className="dis-footer__logo"
              loading="lazy"
            />
            <p className="dis-footer__blurb">
              Enterprise software, Microsoft cloud and fiscal technology,
              engineered for organisations that cannot afford to guess.
            </p>
            <ul className="dis-footer__meta">
              <li>
                <a href="mailto:info@diamondinformationsystems.com">
                  <Mail size={14} strokeWidth={1.5} aria-hidden="true" />
                  info@diamondinformationsystems.com
                </a>
              </li>
            </ul>
          </div>

          {columns.map((col) => (
            <nav key={col.title} className="dis-footer__col">
              <h3 className="dis-mono dis-footer__col-title">{col.title}</h3>
              <ul>
                {col.links.map((link) => (
                  <li key={link.label}>
                    <Link to={link.to}>{link.label}</Link>
                  </li>
                ))}
              </ul>
            </nav>
          ))}
        </div>

        <hr className="dis-rule dis-footer__rule" />

        <div className="dis-footer__base">
          <span className="dis-mono dis-footer__fine">
            © {year} Diamond Information Systems
          </span>
          <nav className="dis-footer__legal">
            <Link to="/privacy" className="dis-mono dis-footer__fine">
              Privacy policy
            </Link>
            <span className="dis-mono dis-footer__fine">
              Powering success through innovation
            </span>
          </nav>
        </div>
      </div>
    </footer>
  );
}
